<template>
    <vertical-form-table
        v-model="form"
        v-bind="{
            items,
            class: 'sign-file',
        }"
        @input="emit"
    />
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        /** @type {Object<string, import('@/assets/variables').EmploymentField>} */
        form: {},
    }),
    computed: {
        items() {
            return Object.keys(this.form).map((key) => ({
                key: `${key}.file`,
                term: this.form[key]?.term,
                type: "file",
                required: this.form[key]?.isRequired,

                outlined: true,
            }));
        },
        disabled() {
            return Object.values(this.form).some((item) => item.isRequired && !item.file);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
        disabled() {
            this.emitDisabled();
        },
    },
    methods: {
        init() {
            this.emitDisabled();
            this.sync();
        },

        sync() {
            /** @type {import('@/assets/variables').EmploymentContract} */
            let { fields_employee } = this.value;

            this.form = fields_employee.reduce((form, item) => {
                if (item.type == EMPLOYMENT_FIELD_TYPES.FILE.value) {
                    form[item.tempId] = item;
                }

                return form;
            }, {});
        },

        emit() {
            /** @type {import('@/assets/variables').EmploymentContract} */
            let { fields_employee } = this.value;

            fields_employee = fields_employee.map((item) => this.form[item.tempId] || item);

            this.$emit("input", { ...this.value, fields_employee });
        },

        emitDisabled() {
            this.$emit("setDisabled", this.disabled);
        },
    },
};
</script>

<style lang="scss" scoped>
.sign-file {
    font-weight: 500;
    ::v-deep(.v-divider) {
        display: none;
    }
    ::v-deep(.row.ma-0) {
        > .col-auto {
            width: 100% !important;
            margin: auto 0;
        }
    }
    ::v-deep(.v-input) {
        .v-input__prepend-outer {
            margin-top: 12px;
        }
    }

    @media (min-width: 768px) {
        ::v-deep(.row.ma-0) {
            > .col-auto {
                width: 120px !important;
            }
        }
    }

    @media (min-width: 1024px) {
        font-size: 16px;
        ::v-deep(.row.ma-0) {
            > .col {
                padding: 16px 20px !important;
            }
            > .col-auto {
                width: 194px !important;
            }
        }
    }
}
</style>
